// Generic swim-lane timeline geometry + layout constants (no domain vocabulary).
// Drilling/stimulation codes, lanes, and colors live in each consuming feature.

// ── Time geometry ───────────────────────────────────────────────────────────
export const HOURS_PER_DAY = 24;
export const MS_PER_HOUR = 3_600_000;
export const MS_PER_DAY = HOURS_PER_DAY * MS_PER_HOUR;
/** Visible window = the day of interest ± WINDOW_PAD_HOURS. Narrow on purpose,
 *  so ~15-min entries are legible (a full multi-day view is too coarse); the
 *  ±pad still shows midnight crossovers into the adjacent days. */
export const WINDOW_PAD_HOURS = 4;
export const WINDOW_HOURS = HOURS_PER_DAY + 2 * WINDOW_PAD_HOURS; // 32
export const WINDOW_MS = WINDOW_HOURS * MS_PER_HOUR;
/** Day boundary (local hour) the stream is sliced on for derived rollups.
 *  Default midnight; operator-specific cutoff becomes template-driven later. */
export const DAY_BOUNDARY_HOUR = 0;
/** Click-to-create snaps to this granularity (minutes). */
export const SNAP_MINUTES = 15;
/** Default duration (hours) for a freshly click-created block. */
export const DEFAULT_BLOCK_HOURS = 1;

// ── Lane row heights (px) ───────────────────────────────────────────────────
export const LANE_HEIGHT = 46;
export const CRITICAL_LANE_HEIGHT = 70; // thicker — the spine stands out
export const LANE_LABEL_WIDTH = 132;
export const AXIS_HEIGHT = 44;
